import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { FocusService } from 'app/core/services/focus.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-pdf-viewer',
  styleUrls: ['./pdf-viewer.component.scss'],
  templateUrl: './pdf-viewer.component.html',
})
export class PdfViewerComponent {
  @ViewChild('_pdfLink') private _pdfLink: ElementRef;

  private _focusService = inject(FocusService);

  public download(blob: Blob, filename: string): void {
    const blobURL = window.URL.createObjectURL(blob);
    this._pdfLink.nativeElement.href = blobURL;

    // Add a download attribute to force the browser to download the PDF instead of opening it.
    this._pdfLink.nativeElement.download = filename;
    this._pdfLink.nativeElement.click();
    this._focusService.setTimeoutOutsideAngular(() => {
      // For Chrome and Safari, it's necessary to delay revoking the ObjectUrl
      window.URL.revokeObjectURL(blobURL);
    }, 3600000);
  }

  public open(blob: Blob, filename: string): void {
    // https://stackoverflow.com/questions/53548182/can-i-set-the-filename-of-a-pdf-object-displayed-in-chrome
    const file = new File([blob], filename, { type: 'application/pdf' });
    const fileUrl = window.URL.createObjectURL(file);
    window.open(fileUrl, '_blank');
    this._focusService.setTimeoutOutsideAngular(() => {
      // For Chrome and Safari, it's necessary to delay revoking the ObjectUrl
      window.URL.revokeObjectURL(fileUrl);
    }, 3600000);
  }
}
